import { NavigateFunction } from "react-router-dom";
import * as Yup from "yup";
import { TUseTranslationTfn } from "../../data/AppType";
import {
  DEFAULT_STATUS_CODE_SUCCESS,
  MESSAGE_UNKNOWN_ERROR_OCCURRED,
} from "../../utils/AppConstants";
import {
  handleError,
  prepareMessageFromParams,
  sweetAlertError,
  toastError,
  toastSuccess,
} from "../../utils/AppFunctions";
import { CHANGE_PASSWORD } from "../../services/Endpoints";

export interface IChangePassForm {
  new_password: string;
  confirm_password: string;
  old_password: string;
}

export const validationSchemaChangePassWord = (t: TUseTranslationTfn) =>
  Yup.object({
    old_password: Yup.string().required(
      prepareMessageFromParams(t("error_message_required"), [
        ["fieldName", t("old_password")],
      ])
    ),
    new_password: Yup.string()
      .required(
        prepareMessageFromParams(t("error_message_required"), [
          ["fieldName", t("new_password")],
        ])
      )
      .max(
        18,
        prepareMessageFromParams(t("error_message_max_length"), [
          ["fieldName", t("new_password")],
          ["max", "18"],
        ])
      )
      .min(
        8,
        prepareMessageFromParams(t("error_message_min_length"), [
          ["fieldName", t("new_password")],
          ["min", "8"],
        ])
      )
      .matches(
        /\d/,
        prepareMessageFromParams(t("error_message_required_number"), [
          ["fieldName", t("new_password")],
        ])
      )
      .matches(
        /[!@#$%^&*(),.?":{}|<>]/,
        prepareMessageFromParams(
          t("error_message_required_special_character"),
          [["fieldName", t("new_password")]]
        )
      )
      .matches(
        /[A-Z]/,
        prepareMessageFromParams(t("error_message_required_uppercase"), [
          ["fieldName", t("new_password")],
        ])
      )
      .notOneOf(
        [Yup.ref("old_password")],
        prepareMessageFromParams(t("error_message_same_value"), [
          ["fieldOne", t("new_password")],
          ["fieldTwo", t("old_password")],
        ])
      ),
    confirm_password: Yup.string()
      .required(
        prepareMessageFromParams(t("error_message_required"), [
          ["fieldName", t("confirm_password")],
        ])
      )
      .oneOf(
        [Yup.ref("new_password")],
        prepareMessageFromParams(t("error_message_match"), [
          ["fieldName", t("confirm_password")],
        ])
      ),
  });

export const initialValuesChangePass = {
  old_password: "",
  new_password: "",
  confirm_password: "",
};

export const submitChangePassword = async (
  values: IChangePassForm,
  navigation: NavigateFunction
) => {
  try {
    const { old_password, new_password, confirm_password } = values;
    const payload = {
      old_password: old_password,
      new_password: new_password,
      confirm_password: confirm_password,
    };

    const changePassword = await CHANGE_PASSWORD(payload);

    if (changePassword && changePassword.code === DEFAULT_STATUS_CODE_SUCCESS) {
      localStorage.clear();
      toastSuccess(changePassword?.message);
      navigation("/");
    } else {
      sweetAlertError({
        message:
          changePassword?.data.message ||
          changePassword?.data.data[0].msg ||
          MESSAGE_UNKNOWN_ERROR_OCCURRED,
      });
    }
  } catch (e: any) {
    toastError(e?.response.message || MESSAGE_UNKNOWN_ERROR_OCCURRED);
    handleError(e, "submitChangePassword");
  }
};
